var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-form", {
        ref: "baseForm",
        attrs: { fields: _vm.fields, warehouseId: _vm.warehouseId },
        on: { change: _vm.onChange },
        model: {
          value: _vm.dataContainer,
          callback: function($$v) {
            _vm.dataContainer = $$v
          },
          expression: "dataContainer"
        }
      }),
      _vm._v(" "),
      _vm.dataContainer
        ? _c(
            "div",
            { staticClass: "btn-validation" },
            [
              _c("sc-button", {
                attrs: {
                  text: "Validar",
                  theme: "primary",
                  disabled: _vm.isValidated
                },
                on: {
                  click: function($event) {
                    _vm.onClickValidate()
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26eca272", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26eca272","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/credentials/ScCredentialsForm.vue
// module id = null
// module chunks = 